export default "__VITE_ASSET__CJKL$U4q__"